export const ImmediateFamily = [
    {
        id: "mother",
        korean: "어머니",
        english: "Mother",
        romanization: "eomeoni",
    },
    {
        id: "father",
        korean: "아버지",
        english: "Father",
        romanization: "abeoji",
    },
    {
        id: "olderBrother_maleSpeaker",
        korean: "형",
        english: "Older brother (for male speaker)",
        romanization: "hyeong",
    },
    {
        id: "olderBrother_femaleSpeaker",
        korean: "오빠",
        english: "Older brother (for female speaker)",
        romanization: "oppa",
    },
    {
        id: "olderSister_maleSpeaker",
        korean: "누나",
        english: "Older sister (for male speaker)",
        romanization: "nuna",
    },
    {
        id: "olderSister_femaleSpeaker",
        korean: "언니",
        english: "Older sister (for female speaker)",
        romanization: "eonni",
    },
    {
        id: "youngerBrother",
        korean: "남동생",
        english: "Younger brother",
        romanization: "namdongsaeng",
    },
    {
        id: "youngerSister",
        korean: "여동생",
        english: "Younger sister",
        romanization: "yeodongsaeng",
    },
    {
        id: "parents",
        korean: "부모님",
        english: "Parents",
        romanization: "bumonim",
    },
    {
        id: "child",
        korean: "아이",
        english: "Child",
        romanization: "ai",
    },
    {
        id: "son",
        korean: "아들",
        english: "Son",
        romanization: "adeul",
    },
    {
        id: "daughter",
        korean: "딸",
        english: "Daughter",
        romanization: "ttal",
    },
];

export const ExtendedFamily = [
    {
        id: "grandfather",
        korean: "할아버지",
        english: "Grandfather",
        romanization: "harabeoji",
    },
    {
        id: "grandmother",
        korean: "할머니",
        english: "Grandmother",
        romanization: "halmeoni",
    },
    {
        id: "grandparents",
        korean: "조부모님",
        english: "Grandparents",
        romanization: "jobumonim",
    },
    {
        id: "uncle_fathersSide",
        korean: "삼촌",
        english: "Uncle (father’s side)",
        romanization: "samchon",
    },
    {
        id: "uncle_mothersSide",
        korean: "외삼촌",
        english: "Uncle (mother’s side)",
        romanization: "oesamchon",
    },
    {
        id: "aunt_fathersSide",
        korean: "고모",
        english: "Aunt (father’s side)",
        romanization: "gomo",
    },
    {
        id: "aunt_mothersSide",
        korean: "이모",
        english: "Aunt (mother’s side)",
        romanization: "imo",
    },
    {
        id: "cousin_male",
        korean: "사촌 형제",
        english: "Male cousin",
        romanization: "sachon hyeongje",
    },
    {
        id: "cousin_female",
        korean: "사촌 자매",
        english: "Female cousin",
        romanization: "sachon jamae",
    },
    {
        id: "niece",
        korean: "조카딸",
        english: "Niece",
        romanization: "jokattal",
    },
    {
        id: "nephew",
        korean: "조카",
        english: "Nephew",
        romanization: "joka",
    },
];

export const MaritalFamily = [
    {
        id: "husband",
        korean: "남편",
        english: "Husband",
        romanization: "nampyeon",
    },
    {
        id: "wife",
        korean: "아내",
        english: "Wife",
        romanization: "anae",
    },
    {
        id: "spouse",
        korean: "배우자",
        english: "Spouse",
        romanization: "bae-uja",
    },
    {
        id: "father_in_law",
        korean: "시아버지",
        english: "Father-in-law (for wife)",
        romanization: "siabeoji",
    },
    {
        id: "mother_in_law",
        korean: "시어머니",
        english: "Mother-in-law (for wife)",
        romanization: "sieomeoni",
    },
    {
        id: "father_in_law_husband",
        korean: "장인어른",
        english: "Father-in-law (for husband)",
        romanization: "jangineoreun",
    },
    {
        id: "mother_in_law_husband",
        korean: "장모님",
        english: "Mother-in-law (for husband)",
        romanization: "jangmonim",
    },
    {
        id: "brother_in_law",
        korean: "시형 / 처남",
        english: "Brother-in-law",
        romanization: "sihyeong / cheonam",
    },
    {
        id: "sister_in_law",
        korean: "시누이 / 처제",
        english: "Sister-in-law",
        romanization: "sinui / cheoje",
    },
    {
        id: "son_in_law",
        korean: "사위",
        english: "Son-in-law",
        romanization: "sawi",
    },
    {
        id: "daughter_in_law",
        korean: "며느리",
        english: "Daughter-in-law",
        romanization: "myeoneuri",
    },
];


export const RespectfulTitles = [
    {
        id: "father",
        korean: "아버지",
        english: "Father",
        romanization: "abeoji",
    },
    {
        id: "mother",
        korean: "어머니",
        english: "Mother",
        romanization: "eomeoni",
    },
    {
        id: "dad",
        korean: "아빠",
        english: "Dad",
        romanization: "appa",
    },
    {
        id: "mom",
        korean: "엄마",
        english: "Mom",
        romanization: "eomma",
    },
    {
        id: "older_brother_male",
        korean: "형",
        english: "Older brother (for males)",
        romanization: "hyeong",
    },
    {
        id: "older_brother_female",
        korean: "오빠",
        english: "Older brother (for females)",
        romanization: "oppa",
    },
    {
        id: "older_sister_male",
        korean: "누나",
        english: "Older sister (for males)",
        romanization: "nuna",
    },
    {
        id: "older_sister_female",
        korean: "언니",
        english: "Older sister (for females)",
        romanization: "eonni",
    },
    {
        id: "grandfather",
        korean: "할아버지",
        english: "Grandfather",
        romanization: "harabeoji",
    },
    {
        id: "grandmother",
        korean: "할머니",
        english: "Grandmother",
        romanization: "halmeoni",
    },
    {
        id: "uncle",
        korean: "삼촌",
        english: "Uncle",
        romanization: "samchon",
    },
    {
        id: "aunt",
        korean: "이모",
        english: "Aunt (maternal)",
        romanization: "imo",
    },
];


export const ChildrenSiblings = [
    {
        id: "child",
        korean: "아이",
        english: "Child",
        romanization: "ai",
    },
    {
        id: "son",
        korean: "아들",
        english: "Son",
        romanization: "adeul",
    },
    {
        id: "daughter",
        korean: "딸",
        english: "Daughter",
        romanization: "ttal",
    },
    {
        id: "baby",
        korean: "아기",
        english: "Baby",
        romanization: "agi",
    },
    {
        id: "brother",
        korean: "남동생",
        english: "Younger brother",
        romanization: "nam-dongsaeng",
    },
    {
        id: "sister",
        korean: "여동생",
        english: "Younger sister",
        romanization: "yeo-dongsaeng",
    },
    {
        id: "siblings",
        korean: "형제자매",
        english: "Siblings",
        romanization: "hyeong-je-ja-mae",
    },
    {
        id: "grandson",
        korean: "손자",
        english: "Grandson",
        romanization: "son-ja",
    },
    {
        id: "granddaughter",
        korean: "손녀",
        english: "Granddaughter",
        romanization: "son-nyeo",
    },
    {
        id: "niece",
        korean: "조카딸",
        english: "Niece",
        romanization: "jo-ka-ttal",
    },
    {
        id: "nephew",
        korean: "조카",
        english: "Nephew",
        romanization: "jo-ka",
    },
];

